// ─── Constants ────────────────────────────────────────────────────────────────

/**
 * Fallback map/search center (Paris) used whenever no address-derived coordinates are
 * available yet — e.g. before a user has selected/geocoded an address. Shared so the
 * autocomplete `at` bias and every `AddressMap` consumer agree on the same default.
 */
export const DEFAULT_MAP_CENTER = { lat: 48.8566, lng: 2.3522 } as const;
